<div class="d-flex card" *ngIf="kitchenDevicePreferences">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">FocusKitchen</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="kitchenPreferencesSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'print-magnifying-glass']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Orders</div>
			</ng-template>
			<app-kitchen-print-orders></app-kitchen-print-orders>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'tablet']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Stations</div>
			</ng-template>
			<app-kitchen-device-list></app-kitchen-device-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'print']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Printers</div>
			</ng-template>
			<app-printer-device-list></app-printer-device-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cogs']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Kitchen Setup</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col-12 p-md-6">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#urgentTimeInput
							[(ngModel)]="kitchenDevicePreferences.urgentTime"
							suffix=" minutes"
							inputStyleClass="text-right"
							styleClass="w-100"
							(ngModelChange)="changesToSave = true"
						></p-inputNumber>
						<label for="urgentTimeInput">Urgent Order Time</label>
					</span>
				</div>
				<div class="p-col-12 p-md-6">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#maxRetryDurationInput
							[(ngModel)]="kitchenDevicePreferences.maxRetryDuration"
							suffix=" seconds"
							max="1200"
							(ngModelChange)="changesToSave = true"
							inputStyleClass="text-right"
							styleClass="w-100"
						></p-inputNumber>
						<label for="maxRetryDurationInput">Max Order Retry Duration</label>
					</span>
					<div class="descriptionText">Focus will retry for this duration to send an order to a venue's FocusKitchen device.</div>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'comment-sms']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">OrderReady SMS</div>
			</ng-template>
			<app-kitchen-order-ready-sms-message
				[(kitchenDevicePreferences)]="kitchenDevicePreferences"
				[(changesToSave)]="changesToSave"
			></app-kitchen-order-ready-sms-message>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cup-togo']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Order Type Settings</div>
			</ng-template>
			<app-kitchen-order-type-setup
				[(kitchenDevicePreferences)]="kitchenDevicePreferences"
				[(changesToSave)]="changesToSave"
			></app-kitchen-order-type-setup>
		</p-tabPanel>
	</p-tabView>
</div>

<!-- <div class="card">
	<div class="d-flex overflow-scroll">
		<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="viewMode = 0">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'tablet']" size="lg" class="ms-1 me-2"></fa-icon>
					FocusKitchen Devices
				</div>
			</ng-template>
		</p-button>
		<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="viewMode = 1">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'print']" size="lg" class="ms-1 me-2"></fa-icon>
					Printers
				</div>
			</ng-template>
		</p-button>
		<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="viewMode = 2">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'print-magnifying-glass']" size="lg" class="ms-1 me-2"></fa-icon>
					Print Orders
				</div>
			</ng-template>
		</p-button>
	</div>
	<div>
		<app-kitchen-device-list *ngIf="viewMode === 0"></app-kitchen-device-list>
		<app-printer-device-list *ngIf="viewMode === 1"></app-printer-device-list>
		<app-kitchen-print-orders *ngIf="viewMode === 2"></app-kitchen-print-orders>
	</div>
</div> -->
